// Quiz baseline
import type { QuizCollectionModel } from '@/common/models/quiz.model';
import { QUESTIONS_TYPE } from '@/common/constants/quiz.ts';

// percentStep = 100 / questions count
const percentStep = 1.5;
const percentStep2 = 1.8;
const percentStep3 = 1.95;

export const quiz: QuizCollectionModel = {
  q0: {
    id: 'q0',
    progress: 0,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'select_goal_question' },
    prevLink: '/',
    options: [
      {
        id: 0,
        text: { key: 'select_goal_answer_1' },
        nextLink: '/quiz/q1/question',
        goals: { main: 'goal_feel_fit' },
      },
      {
        id: 1,
        text: { key: 'select_goal_answer_2' },
        nextLink: '/quiz/q1/question',
        goals: { main: 'goal_improve_intimate_health' },
      },
      {
        id: 2,
        text: { key: 'select_goal_answer_3' },
        nextLink: '/quiz/q1/question',
        goals: { main: 'goal_recover_after_pregnancy' },
      },
      {
        id: 3,
        text: { key: 'select_goal_answer_4' },
        nextLink: '/quiz/q1/question',
        goals: { main: 'goal_all' },
      },
    ],
  },
  q1: {
    id: 'q1',
    progress: percentStep,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q1_question' },
    prevLink: '/quiz/q0/question',
    nextLink: '/quiz/pf1/pf',
    options: [
      { id: 0, text: { key: 'q1_answer_1' } },
      { id: 1, text: { key: 'q1_answer_2' } },
      { id: 2, text: { key: 'q1_answer_3' } },
      { id: 3, text: { key: 'q1_answer_4' } },
    ],
  },
  pf1: {
    id: 'pf1',
    progress: percentStep * 2,
    type: QUESTIONS_TYPE.PF,
    nextLink: '/quiz/q2/question',
    prevLink: '/quiz/q1/question',
    content: {
      titleKey: 'pf1_title',
      textKey: 'pf1_body',
      imageUrl: 'pf_muscles.webp',
    },
  },
  q2: {
    id: 'q2',
    progress: percentStep * 3,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q2_question' },
    prevLink: '/quiz/pf1/PF',
    nextLink: '/quiz/q3/rate',
    options: [
      { id: 0, text: { key: 'q2_answer_1' } },
      { id: 1, text: { key: 'q2_answer_2' } },
      { id: 2, text: { key: 'q2_answer_3' } },
      { id: 3, text: { key: 'q2_answer_4' } },
      { id: 4, text: { key: 'q2_answer_5' } },
    ],
  },
  q3: {
    id: 'q3',
    progress: percentStep * 4,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q3_question' },
    prevLink: '/quiz/q2/question',
    nextLink: '/quiz/q4/rate',
    leftRate: { key: 'not_satisfied' },
    rightRate: { key: 'very_satisfied' },
  },
  q4: {
    id: 'q4',
    progress: percentStep * 5,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q4_question' },
    prevLink: '/quiz/q3/rate',
    nextLink: '/quiz/q5/question',
    leftRate: { key: 'low' },
    rightRate: { key: 'high' },
  },
  q5: {
    id: 'q5',
    progress: percentStep * 6,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q5_question' },
    prevLink: '/quiz/q4/rate',
    nextLink: '/quiz/libido1/libido',
    options: [
      { id: 0, text: { key: 'q5_answer_1' } },
      { id: 1, text: { key: 'q5_answer_2' } },
      { id: 2, text: { key: 'q5_answer_3' } },
      { id: 3, text: { key: 'q5_answer_4' } },
      { id: 4, text: { key: 'q5_answer_5' } },
    ],
  },
  libido1: {
    id: 'libido1',
    progress: percentStep * 7,
    type: QUESTIONS_TYPE.LIBIDO,
    prevLink: '/quiz/q5/question',
    nextLink: '/quiz/q6/question',
    content: {
      titleKey: 'libido_title',
      imageUrl: 'libido.webp',
      textKey: '',
    },
    sources: [
      {
        textKey: 'libido_source_name',
        iconName: 'biotechnology',
      },
    ],
  },
  q6: {
    id: 'q6',
    progress: percentStep * 8,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q6_question' },
    prevLink: '/quiz/libido1/libido',
    nextLink: '/quiz/q7/question',
    options: [
      { id: 0, text: { key: 'q6_answer_1' } },
      { id: 1, text: { key: 'q6_answer_2' } },
      { id: 2, text: { key: 'q6_answer_3' } },
      { id: 3, text: { key: 'q6_answer_4' } },
      { id: 4, text: { key: 'q6_answer_5' } },
    ],
  },
  q7: {
    id: 'q7',
    progress: percentStep * 9,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q7_question' },
    prevLink: '/quiz/q6/question',
    nextLink: '/quiz/pain1/pain',
    options: [
      { id: 0, text: { key: 'q7_answer_1' } },
      { id: 1, text: { key: 'q7_answer_2' } },
      { id: 2, text: { key: 'q7_answer_3' } },
      { id: 3, text: { key: 'q7_answer_4' } },
      { id: 4, text: { key: 'q7_answer_5' } },
    ],
  },
  pain1: {
    id: 'pain1',
    progress: percentStep * 10,
    type: QUESTIONS_TYPE.PAIN,
    prevLink: '/quiz/q7/question',
    nextLink: '/quiz/q8/question',
    content: {
      titleKey: 'pain_title',
      imageUrl: 'pain.webp',
      textKey: '',
    },
    sources: [
      {
        textKey: 'libido_source_name',
        iconName: 'biotechnology',
      },
      {
        textKey: 'source_pain_title',
        iconName: 'baniha',
      },
    ],
  },
  q8: {
    id: 'q8',
    progress: percentStep * 11,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q8_question' },
    prevLink: '/quiz/pain1/pain',
    nextLink: '/quiz/q9/question',
    options: [
      { id: 0, text: { key: 'q8_answer_1' } },
      { id: 1, text: { key: 'q8_answer_2' } },
      { id: 2, text: { key: 'q8_answer_3' } },
    ],
  },
  q9: {
    id: 'q9',
    progress: percentStep * 12,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q9_question' },
    prevLink: '/quiz/q8/question',
    nextLink: '/quiz/bladder1/bladder',
    options: [
      { id: 0, text: { key: 'q9_answer_1' } },
      { id: 1, text: { key: 'q9_answer_2' } },
      { id: 2, text: { key: 'q9_answer_3' } },
    ],
  },
  bladder1: {
    id: 'bladder1',
    progress: percentStep * 13,
    type: QUESTIONS_TYPE.BLADDER,
    prevLink: '/quiz/q9/question',
    nextLink: '/quiz/q10/rate',
    content: {
      titleKey: 'bladder_title',
      imageUrl: 'Bladder.webp',
      textKey: '',
    },
    sources: [
      {
        textKey: 'libido_source_name',
        iconName: 'biotechnology',
      },
    ],
  },
  q10: {
    id: 'q10',
    progress: percentStep * 14,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q10_question' },
    prevLink: '/quiz/bladder1/bladder',
    nextLink: '/quiz/q11/rate',
    leftRate: { key: 'not_difficult' },
    rightRate: { key: 'very_difficult' },
  },
  q11: {
    id: 'q11',
    progress: percentStep * 15,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q11_question' },
    prevLink: '/quiz/q10/rate',
    nextLink: '/quiz/q12/question',
    leftRate: { key: 'not_difficult' },
    rightRate: { key: 'very_difficult' },
  },
  q12: {
    id: 'q12',
    progress: percentStep * 16,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q12_question' },
    prevLink: '/quiz/q11/rate',
    nextLink: '/quiz/orgasm1/orgasm',
    options: [
      { id: 0, text: { key: 'q12_answer_1' } },
      { id: 1, text: { key: 'q12_answer_2' } },
      { id: 2, text: { key: 'q12_answer_3' } },
      { id: 3, text: { key: 'q12_answer_4' } },
      { id: 4, text: { key: 'q12_answer_5' } },
    ],
  },
  orgasm1: {
    id: 'orgasm1',
    progress: percentStep * 17,
    type: QUESTIONS_TYPE.ORGASM,
    prevLink: '/quiz/q12/question',
    nextLink: '/quiz/q13/question',
    content: {
      titleKey: 'orgasm_title',
      imageUrl: 'Orgasm.webp',
      textKey: '',
    },
    sources: [
      {
        textKey: 'libido_source_name',
        iconName: 'biotechnology',
      },
    ],
  },
  q13: {
    id: 'q13',
    progress: percentStep * 18,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q13_question' },
    prevLink: '/quiz/orgasm1/orgasm',
    nextLink: '/quiz/q14/question',
    options: [
      { id: 0, text: { key: 'q13_answer_1' } },
      { id: 1, text: { key: 'q13_answer_2' } },
      { id: 2, text: { key: 'q13_answer_3' } },
      { id: 3, text: { key: 'q13_answer_4' } },
      { id: 4, text: { key: 'q13_answer_5' } },
    ],
  },
  q14: {
    id: 'q14',
    progress: percentStep * 19,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q14_question' },
    prevLink: '/quiz/q13/question',
    nextLink: '/quiz/q15/question',
    options: [
      { id: 0, text: { key: 'q14_answer_1' } },
      { id: 1, text: { key: 'q14_answer_2' } },
      { id: 2, text: { key: 'q14_answer_3' } },
      { id: 3, text: { key: 'q14_answer_4' } },
      { id: 4, text: { key: 'q14_answer_5' } },
    ],
  },
  q15: {
    id: 'q15',
    progress: percentStep * 20,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q15_question' },
    prevLink: '/quiz/q14/question',
    nextLink: '/quiz/q16/question',
    options: [
      { id: 0, text: { key: 'q15_answer_1' } },
      { id: 1, text: { key: 'q15_answer_2' } },
      { id: 2, text: { key: 'q15_answer_3' } },
      { id: 3, text: { key: 'q15_answer_4' } },
      { id: 4, text: { key: 'q15_answer_5' } },
    ],
  },
  q16: {
    id: 'q16',
    progress: percentStep * 21,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q16_question' },
    prevLink: '/quiz/q15/question',
    nextLink: '/quiz/graph1/graph',
    options: [
      { id: 0, text: { key: 'q16_answer_1' } },
      { id: 1, text: { key: 'q16_answer_2' } },
      { id: 2, text: { key: 'q16_answer_3' } },
      { id: 3, text: { key: 'q16_answer_4' } },
      { id: 4, text: { key: 'q16_answer_5' } },
    ],
  },
  graph1: {
    id: 'graph1',
    progress: percentStep * 22,
    type: QUESTIONS_TYPE.GRAPH,
    prevLink: '/quiz/q16/question',
    nextLink: '/quiz/q17/women',
  },
  q17: {
    id: 'q17',
    progress: percentStep * 23,
    type: QUESTIONS_TYPE.WOMEN,
    prevLink: '/quiz/graph1/graph',
    nextLink: '/quiz/q18/question',
    question: { key: 'q17_question' },
    options: [
      { id: 0, text: { key: 'q17_answer_1' }, imageUrl: '/images/img_body_thin.webp' },
      { id: 1, text: { key: 'q17_answer_2' }, imageUrl: '/images/img_body_average.webp' },
      { id: 2, text: { key: 'q17_answer_3' }, imageUrl: '/images/img_body_curvy_f.webp' },
      { id: 3, text: { key: 'q17_answer_4' }, imageUrl: '/images/img_body_plus_size.webp' },
    ],
  },
  q18: {
    id: 'q18',
    progress: percentStep2 * 24,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q18_question' },
    prevLink: '/quiz/q17/women',
    nextLink: '/quiz/q19/women',
    options: [
      { id: 0, text: { key: 'q18_answer_1' } },
      { id: 1, text: { key: 'q18_answer_2' } },
      { id: 2, text: { key: 'q18_answer_3' } },
      { id: 3, text: { key: 'q18_answer_4' } },
      { id: 4, text: { key: 'q18_answer_5' } },
    ],
  },
  q19: {
    id: 'q19',
    progress: percentStep2 * 25,
    type: QUESTIONS_TYPE.WOMEN,
    prevLink: '/quiz/q18/question',
    nextLink: '/quiz/q20/women',
    question: { key: 'q19_question' },
    options: [
      { id: 0, text: { key: 'q19_answer_1' }, imageUrl: '/images/img_ideal_body_toned.webp' },
      { id: 1, text: { key: 'q19_answer_2' }, imageUrl: '/images/img_ideal_body_curvy_s.webp' },
      { id: 2, text: { key: 'q19_answer_3' }, imageUrl: '/images/img_ideal_body_athletic.webp' },
      { id: 3, text: { key: 'q19_answer_4' }, imageUrl: '/images/img_ideal_body_thin.webp' },
    ],
  },
  q20: {
    id: 'women1',
    progress: percentStep2 * 26,
    type: QUESTIONS_TYPE.WOMEN,
    prevLink: '/quiz/q19/women',
    nextLink: '/quiz/q21/question',
    question: { key: 'q20_question' },
    options: [
      { id: 0, text: { key: 'q20_answer_1' }, imageUrl: '/images/img_body_area_thighs_buttocks.webp' },
      { id: 1, text: { key: 'q20_answer_2' }, imageUrl: '/images/img_body_area_belly_hips.webp' },
      { id: 2, text: { key: 'q20_answer_3' }, imageUrl: '/images/img_body_area_chest.webp' },
      { id: 3, text: { key: 'q20_answer_4' }, imageUrl: '/images/img_body_area_not_sure.webp' },
    ],
  },
  q21: {
    id: 'q21',
    progress: percentStep2 * 27,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q21_question' },
    prevLink: '/quiz/q20/women',
    nextLink: '/quiz/q22/question',
    options: [
      { id: 0, text: { key: 'q21_answer_1' } },
      { id: 1, text: { key: 'q21_answer_2' } },
      { id: 2, text: { key: 'q21_answer_3' } },
      { id: 3, text: { key: 'q21_answer_4' } },
    ],
  },
  q22: {
    id: 'q22',
    progress: percentStep2 * 28,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q22_question' },
    prevLink: '/quiz/q21/question',
    nextLink: '/quiz/q23/question',
    options: [
      { id: 0, text: { key: 'q22_answer_1' } },
      { id: 1, text: { key: 'q22_answer_2' } },
      { id: 2, text: { key: 'q22_answer_3' } },
    ],
  },
  q23: {
    id: 'q23',
    progress: percentStep2 * 29,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q23_question' },
    prevLink: '/quiz/q22/question',
    nextLink: '/quiz/q24/question',
    options: [
      { id: 0, text: { key: 'q23_answer_1' } },
      { id: 1, text: { key: 'q23_answer_2' } },
      { id: 2, text: { key: 'q23_answer_3' } },
      { id: 3, text: { key: 'q23_answer_4' } },
    ],
  },
  q24: {
    id: 'q24',
    progress: percentStep2 * 30,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q24_question' },
    prevLink: '/quiz/q23/question',
    nextLink: '/quiz/body1/body',
    options: [
      { id: 0, text: { key: 'q24_answer_1' } },
      { id: 1, text: { key: 'q24_answer_2' } },
      { id: 2, text: { key: 'q24_answer_3' } },
    ],
  },
  body1: {
    id: 'body1',
    progress: -1,
    type: QUESTIONS_TYPE.BODY,
    prevLink: '/quiz/q24/question',
    nextLink: '/quiz/q25/rate',
  },
  q25: {
    id: 'q25',
    progress: percentStep2 * 32,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q25_question' },
    prevLink: '/quiz/body1/body',
    nextLink: '/quiz/q26/question',
    leftRate: { key: 'low' },
    rightRate: { key: 'high' },
  },
  q26: {
    id: 'q26',
    progress: percentStep2 * 33,
    type: QUESTIONS_TYPE.DEFAULT,
    question: { key: 'q26_question' },
    prevLink: '/quiz/q25/rate',
    nextLink: '/quiz/q27/rate',
    options: [
      { id: 0, text: { key: 'q26_answer_1' } },
      { id: 1, text: { key: 'q26_answer_2' } },
      { id: 2, text: { key: 'q26_answer_3' } },
      { id: 3, text: { key: 'q26_answer_4' } },
    ],
  },
  q27: {
    id: 'q27',
    progress: percentStep2 * 34,
    type: QUESTIONS_TYPE.RATE,
    question: { key: 'q27_question' },
    prevLink: '/quiz/q26/question',
    nextLink: '/quiz/analyzing-answers',
    leftRate: { key: 'unhealthy' },
    rightRate: { key: 'healthy' },
  },
  q28: {
    id: 'q28',
    progress: percentStep3 * 35,
    type: QUESTIONS_TYPE.HEIGHT,
    prevLink: '/quiz/analyzing-answers',
    nextLink: '/quiz/q29/weight',
  },
  q29: {
    id: 'q29',
    progress: percentStep3 * 42,
    type: QUESTIONS_TYPE.WEIGHT,
    prevLink: '/quiz/q28/height',
    nextLink: '/quiz/q30/name',
  },
  q30: {
    id: 'q30',
    progress: percentStep3 * 48,
    type: QUESTIONS_TYPE.NAME,
    prevLink: '/quiz/q28/weight',
    nextLink: '/quiz/card',
  },
};
